<template>
    <div
        class="block-tool-time"
        @click.stop
    >
        <div class="date-pick">
            <el-dropdown
                trigger="hover"
                @command="handleCommand"
                @visible-change="changeDropIcon"
                placement="bottom"
                :hide-on-click="true"
            >
                <span class="dropdown-link">
                    <span class="format">切换格式</span><i
                        class="el-icon-caret-bottom"
                        :class="{ 'is-rotate': isVisDrop }"
                    ></i>
                </span>
                <el-dropdown-menu
                    slot="dropdown"
                    class="block-tool-time-dropdownlist"
                >
                    <el-dropdown-item
                        v-for="pattern in patternConfig"
                        :key="pattern"
                        :command="pattern"
                    >

                        <img
                            class="date"
                            width="122px"
                            :src="getTimeStampImage(pattern)"
                        />

                        <i
                            v-if="block.timestampFormatType === pattern"
                            class="el-icon-check primary-color"
                        ></i>

                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
import qs from 'qs';

export default {
    props: {
        block: Object,//位置块
    },
    data () {
        return {
            patternConfig: ['SECONDARY_THIRD', 'CHINESE_Y_M_D','CHINESE_Y_M_D_MINUTE','CHINESE_Y_M_D_HOUR_MINUTE'],
            isVisDrop: false
        };
    },
    inject: ['signPage'],
    computed: {
        //可选择的格式列表
        patternList () {
            return this.patternConfig.filter(item => item !== this.block.timestampFormatType);
        },
    },
    methods: {
        //下拉图标样式
        changeDropIcon (val) {
            this.isVisDrop = val;
        },
        //选择时间戳
        handleCommand (val) {
            this.$set(this.block, 'timestampFormatType', val);
            this.$set(this.block, 'src', this.getTimeStampImage(val));
        },
        // 时间戳图片
        getTimeStampImage (formatType = 'SECONDARY_THIRD') {
            const param = { formatType, zwdt_access_token: this.zwdt_access_token || this.$route.query.zwdt_access_token };
            return `${this.BASE_APP_PATH}/seal/timestamp?${qs.stringify(param)}`;
        },
    }
};
</script>

<style lang="less" scoped>
.block-tool-time {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 34px;
    line-height: 34px;
    border-radius: 4px;
    user-select: none;
    padding: 0 10px;
    background: rgba(247, 248, 248, 1);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.13);
    border-radius: 3px;
    border: 1px solid rgba(229, 231, 234, 1);
    white-space: nowrap;
    .date-pick {
        width: 66px;
        .el-dropdown-menu {
            padding: 0;
        }
        .dropdown-link {
            cursor: pointer;
            white-space: nowrap;
            .format {
                user-select: none;
                margin-right: 3px;
                color: #383838;
                font-family: PingFangSC-Regular, PingFangSC;
                font-size: 12px;
            }
            .el-icon-caret-bottom {
                transition: all 0.3s;
                color: #c1c6cd;
                &.is-rotate {
                    transform: rotate(-180deg);
                }
            }
        }
    }
}
</style>

<style lang="less">
.block-tool-time-dropdownlist {
    user-select: none;
    padding: 0;
    &.el-dropdown-menu {
        overflow: visible;
        top: 10px;
    }
    .el-dropdown-menu__item {
        padding: 0 10px;
        display: flex;
        align-items: center;
        height: 32px;
        &:hover {
            background: #f5f5f5;
            color: #666666;
        }
    }
}

.primary-color {
    color: #c4ad7b;
}
</style>
